import React from 'react'
import { CmSensorMeasuresChart } from './CmSensorMeasuresChart'
import { useSelector } from 'react-redux'
import { buildThresholdLines } from '../../../../helpers/getThresholdsColors'

export const CmSensorMeasuresChartWithThresholds = ({
  showThresholds = true,
  centerOn = 'sunset',
  ...props
}) => {
  const thresholds = useSelector(state =>
    centerOn === 'sunrise'
      ? state.contracts.cmAdaptativeThresholdsSunrise
      : state.contracts.cmAdaptativeThresholdsSunset
  )
  const thresholdLines = buildThresholdLines(thresholds)

  const lines = showThresholds ? thresholdLines : []

  return <CmSensorMeasuresChart {...props} centerOn={centerOn} horizontalLines={lines} />
}
